import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Organization } from "@domain/organization/organization";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { ProfilePicture } from "@ui/components/profile/profilePicture";
import { mobile } from "@ui/styles/utils";

interface JoinOrganizationProps extends React.HTMLAttributes<HTMLDivElement> {
	organization: Organization;
}
export const JoinOrganization: React.FC<JoinOrganizationProps> = ({ organization, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<ProfilePicture shadowed size={86} picture={organization.avatar} fallbackType={organization.type} />
			<Title>{I18n.t("organization.join.title", { name: organization.primaryName })}</Title>
			<a href={`mailto:${organization.email}`}>
				<PrimaryButton>{I18n.t("organization.join.button")}</PrimaryButton>
			</a>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 45px;
	word-break: break-word;
`;

const Title = styled.div`
	margin: 34px 0 66px;
	@media ${mobile} {
		margin: 20px 0;
	}
	${({ theme }) => theme.textStyles.title};
`;
